import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { PsvLink } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for virtual-tour links nested under a node —
 * `/vr_psv_nodes/{nodeId}/psv_links`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { nodeId: <parent node id> }` to bind to a specific parent
 * node. Note that `nodeId` on a {@link import('@indutrust/factory-model').PsvLink}
 * refers to the **target** node, whereas the URL segment is the **parent**
 * node.
 */
@Service()
export class VrLinkApiClient extends BaseApiClient<PsvLink> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<PsvLink> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/vr_psv_nodes/{nodeId}/psv_links`;
  }
}
